import { render } from "./LoadingIndi.vue?vue&type=template&id=1ce2a7ad&scoped=true"
const script = {}

import "./LoadingIndi.vue?vue&type=style&index=0&id=1ce2a7ad&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ce2a7ad"]])

export default __exports__